import React from 'react';
import ReactDOM from 'react-dom';
// import bugsnag from '@bugsnag/js';
// import bugsnagReact from '@bugsnag/plugin-react';
import App from './App';
import * as serviceWorker from './serviceWorker';

// const bugsnagClient = bugsnag('e6c268ded3e75ef151b416fc5cc6b15e');
// bugsnagClient.use(bugsnagReact, React);

// const ErrorBoundary = bugsnagClient.getPlugin('react');

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);

// bugsnagClient.notify(new Error('Test error'));

serviceWorker.unregister();
